<template>
	<div class="mt-3 container">
		<div class="row">
			<div class="col-sm-6">
				<h3>Project</h3>
				<div class="card">
					<div class="card-body">
						<h4>{{name}}</h4>
						<p class="card-text">{{description}}</p>

						<dl class="row">
							<dt class="col-sm-3">Timeframe</dt>
							<dd class="col-sm-9">{{timeframe}}</dd>
							<dt class="col-sm-3">Budget</dt>
							<dd class="col-sm-9">{{budget}}</dd>
							<dt class="col-sm-3">Tribunal</dt>
							<dd class="col-sm-9">{{tribunal}}</dd>
							<dt class="col-sm-3">Type</dt>
							<dd class="col-sm-9">
								<span class="badge badge-primary mr-1" v-for="t in type">{{t}}</span>
							</dd>

							<dt class="col-sm-3">Owner</dt>
							<dd class="col-sm-9">{{ owner }}</dd>
							<dt class="col-sm-3">Project</dt>
							<dd class="col-sm-9">Top level</dd>
						</dl>
					</div>
				</div>
			</div>

			<div class="col-sm-6">
				<h3 class="mb-3">Structure</h3>
				<div class="card">
					<div class="card-body">
						<div class="row">
							<div class="col"></div>
							<div class="col-md-12">
								<div align-h="between" class="milestone-level mb-3" aria-controls="project_milestone_collaps0" aria-expanded="true" role="button">
									<svg version="1.1" role="presentation" width="16" height="15px" viewBox="0 0 1792 1792" class="fa-icon">
										<path d="M320 256q0 72-64 110v1266q0 13-9.5 22.5t-22.5 9.5h-64q-13 0-22.5-9.5t-9.5-22.5v-1266q-64-38-64-110 0-53 37.5-90.5t90.5-37.5 90.5 37.5 37.5 90.5zM1792 320v763q0 25-12.5 38.5t-39.5 27.5q-215 116-369 116-61 0-123.5-22t-108.5-48-115.5-48-142.5-22q-192 0-464 146-17 9-33 9-26 0-45-19t-19-45v-742q0-32 31-55 21-14 79-43 236-120 421-120 107 0 200 29t219 88q38 19 88 19 54 0 117.5-21t110-47 88-47 54.5-21q26 0 45 19t19 45z"></path>
									</svg>

									<span class="ml-1"> Milestone0.35524934048523105</span>

									<div id="project_milestone_collaps0" class="col-md-12 collapse show" style="">
										<div class="row mt-3 align-items-center">
											<div align-v="center" class="col">
												<svg version="1.1" role="presentation" width="16" height="13px" viewBox="0 0 1792 1792" class="fa-icon">
													<path d="M991 1024l64-256h-254l-64 256h254zM1759 520l-56 224q-7 24-31 24h-327l-64 256h311q15 0 25 12 10 14 6 28l-56 224q-5 24-31 24h-327l-81 328q-7 24-31 24h-224q-16 0-26-12-9-12-6-28l78-312h-254l-81 328q-7 24-31 24h-225q-15 0-25-12-9-12-6-28l78-312h-311q-15 0-25-12-9-12-6-28l56-224q7-24 31-24h327l64-256h-311q-15 0-25-12-10-14-6-28l56-224q5-24 31-24h327l81-328q7-24 32-24h224q15 0 25 12 9 12 6 28l-78 312h254l81-328q7-24 32-24h224q15 0 25 12 9 12 6 28l-78 312h311q15 0 25 12 9 12 6 28z"></path>
												</svg>
												<span class="text-right">Del10.3631089290083822</span>
											</div>
										</div>

										<div class="row mt-3 align-items-center">
											<div align-v="center" class="col">
											<svg version="1.1" role="presentation" width="16" height="13px" viewBox="0 0 1792 1792" class="fa-icon">
												<path d="M991 1024l64-256h-254l-64 256h254zM1759 520l-56 224q-7 24-31 24h-327l-64 256h311q15 0 25 12 10 14 6 28l-56 224q-5 24-31 24h-327l-81 328q-7 24-31 24h-224q-16 0-26-12-9-12-6-28l78-312h-254l-81 328q-7 24-31 24h-225q-15 0-25-12-9-12-6-28l78-312h-311q-15 0-25-12-9-12-6-28l56-224q7-24 31-24h327l64-256h-311q-15 0-25-12-10-14-6-28l56-224q5-24 31-24h327l81-328q7-24 32-24h224q15 0 25 12 9 12 6 28l-78 312h254l81-328q7-24 32-24h224q15 0 25 12 9 12 6 28l-78 312h311q15 0 25 12 9 12 6 28z"></path>
											</svg>

											<span class="text-right"> Del1150.19573510157575047</span>
										</div>
									</div>

									<div class="row mt-3 align-items-center">
										<div align-v="center" class="col">
											<svg version="1.1" role="presentation" width="16" height="13px" viewBox="0 0 1792 1792" class="fa-icon">
												<path d="M991 1024l64-256h-254l-64 256h254zM1759 520l-56 224q-7 24-31 24h-327l-64 256h311q15 0 25 12 10 14 6 28l-56 224q-5 24-31 24h-327l-81 328q-7 24-31 24h-224q-16 0-26-12-9-12-6-28l78-312h-254l-81 328q-7 24-31 24h-225q-15 0-25-12-9-12-6-28l78-312h-311q-15 0-25-12-9-12-6-28l56-224q7-24 31-24h327l64-256h-311q-15 0-25-12-10-14-6-28l56-224q5-24 31-24h327l81-328q7-24 32-24h224q15 0 25 12 9 12 6 28l-78 312h254l81-328q7-24 32-24h224q15 0 25 12 9 12 6 28l-78 312h311q15 0 25 12 9 12 6 28z"></path></svg>

												<span class="text-right"> Del1150.19573510157575047</span>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>

		<div class="row">
			<div class="col-sm-12">
				<h3 class="mb-3">Deliverables</h3>
				<div class="card">
					<div class="card-body">
						<table aria-busy="false" aria-colcount="4" class="table b-table table-hover" style="cursor: pointer;" aria-rowcount="3">
							<thead class="">
								<tr>
									<th tabindex="0" aria-colindex="1" aria-label="Click to sort Descending" class="sorting">Deliverable</th>
									<th tabindex="0" aria-colindex="2" aria-label="Click to sort Descending" class="sorting">Budget</th>
									<th aria-colindex="3" class="">Skills</th>
									<th aria-colindex="4" class=""></th>
								</tr>
							</thead>

							<tbody class="">
								<tr class="">
									<td aria-colindex="1" class="">Del10.3631089290083822</td>
									<td aria-colindex="2" class="">200 $</td>
									<td aria-colindex="3" class="">
										<span>Non registered</span></td>
										<td aria-colindex="4" class="">
											<span>Internal</span>
										</td>
									</tr>

									<tr class="">
										<td aria-colindex="1">Del1150.19573510157575047</td>
										<td aria-colindex="2">164 $</td>
										<td aria-colindex="3">
											<span>Non registered</span>
										</td>
										<td aria-colindex="4" class="">
											<button type="button" class="btn btn-success">Make offer</button>
										</td>
									</tr>

									<tr class="">
										<td aria-colindex="1" class="">Del1150.19573510157575047</td>
										<td aria-colindex="2" class="">164 $</td>
										<td aria-colindex="3" class="">
											<span>Non registered</span>
										</td>
										<td aria-colindex="4" class="">
											<button type="button" class="btn btn-success">Make offer</button>
										</td>
									</tr>
								</tbody>
							</table>
						</div>
					</div>
			</div>
		</div>

		<div class="row">
			<div class="col-sm-6">
				<app-chat></app-chat>
			</div>
		</div>
	</div>
</template>

<script type="text/javascript">
import Chat from '../Chat.vue'

export default {
	name: 'ProjectDetail',
	data() {
		return {
			name : 'Handcrafted Cotton',
			description : 'Enim ad et id est autem et iste.',
			timeframe : '4 weeks',
			budget : 4000,
			tribunal : 3,
			type : ['freelancer', 'team'],
			owner : '2Rm7pngppudwxYzY12PJfGOQ5vl1'
		}
	},
	components : {
		appChat : Chat
	}

}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/projects/ProjectDetail.vue